import React from 'react';

import InputPercentForm from '../../../../../components/form/InputPercentForm';
import SwitchForm from '../../../../../components/form/SwitchForm';
import Switch from '../../../../../components/input/Switch';
import Select from '../../../../../components/input/Select/Select';
import InputNumber from '../../../../../components/input/InputNumber/InputNumber';
import { formRequiredRules } from '../../../../../lib/formRules';
import { setFeeMaximumNumber } from '../../../../../lib/utils/commonUtils';
import {
  PRODUCT_MANAGEMENT_TYPE,
  PRODUCT_MAXIMUM_STOCK,
  PRODUCT_MINIMUM_STOCK,
  PRODUCT_STATUS,
} from '../../../../../constants/service/app/productConstants';

const columns = (data) => {
  const { isEditable, form, setFeeInfo, setIsGift, productManagementTypeSelectList } = data;

  return [
    {
      title: '상품관리타입',
      dataIndex: 'productManagementType',
      render: (value) => (
        <Select
          value={value}
          onChange={(productManagementType) => setFeeInfo((prev) => ({ ...prev, productManagementType }))}
          list={productManagementTypeSelectList}
          disabled={!data.isEditable}
          isTable={true}
        />
      ),
    },
    {
      title: '선물 여부',
      dataIndex: 'isGift',
      render: (value) => (
        <Switch
          checked={value}
          disabled={!isEditable}
          onChange={(isGift) => {
            setIsGift({ isGift, setData: () => setFeeInfo((prev) => ({ ...prev, isGift })) });
          }}
        />
      ),
    },
    {
      title: '재고',
      dataIndex: 'stockCount',
      render: (value) => (
        <InputNumber
          max={PRODUCT_MAXIMUM_STOCK}
          min={PRODUCT_MINIMUM_STOCK}
          disabled={!data.isEditable}
          unit="개"
          value={value}
          onChange={(stockCount) => {
            setFeeInfo((prev) => ({ ...prev, stockCount }));

            // 재고가 0개일 경우 상품 상태를 품절로 변경
            if (value !== 0) return;
            const productStatus = form.getFieldValue('status');
            productStatus >= PRODUCT_STATUS.NOW_ON_SALE &&
              form.setFieldsValue({
                status: PRODUCT_STATUS.SOLD_OUT,
              });
          }}
        />
      ),
    },
    {
      title: 'PG수수료',
      dataIndex: 'isPgFee',
      render: (value, record) => (
        <SwitchForm
          checked={value}
          disabled={!isEditable || record.productManagementType === PRODUCT_MANAGEMENT_TYPE.PURCHASE}
          onChange={(isPgFee) => setFeeInfo((prev) => ({ ...prev, isPgFee }))}
        />
      ),
    },
    {
      title: '아몬즈 수수료',
      dataIndex: 'amondzFeeRate',
      render: (value, record) => (
        <InputPercentForm
          form={form}
          isEditable={isEditable}
          rules={[formRequiredRules(true, undefined, false)]}
          max={setFeeMaximumNumber([record.marketingFeeRate, record.fulfillmentFeeRate])}
          initialValue={value}
          onChange={(amondzFeeRate) => setFeeInfo((prev) => ({ ...prev, amondzFeeRate }))}
          name="amondzFeeRate"
        />
      ),
    },
    {
      title: '마케팅 수수료',
      dataIndex: 'marketingFeeRate',
      render: (value, record) => (
        <InputPercentForm
          form={form}
          isEditable={isEditable}
          rules={[formRequiredRules(true, undefined, false)]}
          max={setFeeMaximumNumber([record.amondzFeeRate, record.fulfillmentFeeRate])}
          initialValue={value}
          onChange={(marketingFeeRate) => setFeeInfo((prev) => ({ ...prev, marketingFeeRate }))}
          name="marketingFeeRate"
        />
      ),
    },
    {
      title: '풀필먼트 수수료',
      dataIndex: 'fulfillmentFeeRate',
      render: (value, record) => (
        <InputPercentForm
          form={form}
          isEditable={isEditable}
          rules={[formRequiredRules(true, undefined, false)]}
          max={setFeeMaximumNumber([record.amondzFeeRate, record.marketingFeeRate])}
          initialValue={value}
          onChange={(fulfillmentFeeRate) => setFeeInfo((prev) => ({ ...prev, fulfillmentFeeRate }))}
          name="fulfillmentFeeRate"
        />
      ),
    },
  ];
};

export default columns;
